import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Items } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormFraction, FormInput, FormPrice } from './component/form';

const initialState = {
  form: null,
  fractions: null,
  price: null,
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ form, fractions, price }, setState] = React.useState(initialState);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleFractionChange = (v) => {
    setState((prevState) => ({ ...prevState, fractions: v }));
  };

  const $handlePriceChange = (v) => {
    setState((prevState) => ({ ...prevState, price: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      tenant_id: form?.customer?.id,
      ...form,
      ...fractions,
      ...price,
    };

    const submit = await Dispatch(Items.$create(payload));

    if (submit?.message === 'success') {
      History.replace(`/inventory/${submit?.data?.id}`);
    }
  };

  return (
    <Page type="form" className="col-md-8 bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Items" className="border-bottom" />

      <Page.Body className="d-block row px-3">
        <FormInput onInputChange={$handleFormChange} />
        <div className="mt-3">
          <div className="row ">
            <div className="col-md-6 border-end pe-md-4 pe-0">
              <FormPrice onInputChange={$handlePriceChange} />
            </div>
            <div className="col-md-6 px-md-4 px-0">
              <FormFraction onInputChange={$handleFractionChange} />
            </div>
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/inventory`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
